let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("90TNn")).then(() => parcelRequire('6w1sx'));